"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _PropertyIdentifier = require("customer-data-objects/property/PropertyIdentifier");

var _PropertyValueDisplay = require("customer-data-property-utils/PropertyValueDisplay");

var _PropertyValidations = require("customer-data-properties/validation/PropertyValidations");

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _react = _interopRequireWildcard(require("react"));

var _ReferenceDisplayValue = _interopRequireDefault(require("customer-data-reference-ui-components/ReferenceDisplayValue"));

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _UIExpandableText = _interopRequireDefault(require("UIComponents/text/UIExpandableText"));

var DATA_1 = 'hs_analytics_source_data_1';
var DATA_2 = 'hs_analytics_source_data_2';

var connections = _immutable.Set.of('hubspot_team_id', 'dealstage', 'pipeline', 'hs_parent_company_id', 'salesforcecampaignids', DATA_1, DATA_2, 'hs_analytics_first_touch_converting_campaign', 'hs_analytics_last_touch_converting_campaign');

var getTransferableProps = function getTransferableProps(props) {
  return (0, _omit.default)(['actions', 'baseUrl', 'caretRenderer', 'getProperty', 'isInline', 'isExpandableTextInputEnabled', 'InputComponent', 'multiCurrencyCurrencyCode', 'objectType', 'onCancel', 'onInvalidProperty', 'onSecondaryChange', 'options', 'propertyIndex', 'readOnlySourceData', 'resize', 'resolver', 'secondaryChanges', 'showError', 'showPlaceholder', 'subject', 'subjectId', 'wrappers', 'propertyInputComponentConfig', 'onTracking', 'isRequired'], props);
};

function getDataAttributes(props) {
  var results = {};
  Object.keys(props).forEach(function (key) {
    return key.indexOf('data') === 0 ? results[key] = props[key] : undefined;
  });
  return results;
}

var propTypes = {
  autoFocus: _react.PropTypes.bool,
  displayValue: _react.PropTypes.string,
  isExpandableTextInputEnabled: _react.PropTypes.bool,
  objectType: _ObjectTypesType.default,
  onChange: _react.PropTypes.func,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  readOnlySourceData: _react.PropTypes.shape({
    isKnownGuid: _react.PropTypes.func,
    getGuidLabel: _react.PropTypes.func
  }),
  resolver: _ReferenceResolverType.default,
  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  className: _react.PropTypes.string,
  subject: _SubjectType.default,
  getProperty: _react.PropTypes.func
};

var PropertyInputReadOnly =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PropertyInputReadOnly, _Component);

  function PropertyInputReadOnly() {
    (0, _classCallCheck2.default)(this, PropertyInputReadOnly);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputReadOnly).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputReadOnly, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var input = this.refs.input;

      if (input && input.focus) {
        this.refs.input.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          property = _this$props.property,
          objectType = _this$props.objectType,
          onChange = _this$props.onChange,
          value = _this$props.value,
          resolver = _this$props.resolver,
          className = _this$props.className,
          subject = _this$props.subject,
          getProperty = _this$props.getProperty;
      var InputComponent = (0, _PropertyIdentifier.isTextarea)(property) ? _UITextArea.default : _UITextInput.default;

      if (connections.has(property.get('name')) && resolver) {
        return _react.default.createElement(_ReferenceDisplayValue.default, (0, _extends2.default)({}, getDataAttributes(this.props), {
          InputComponent: InputComponent,
          objectType: objectType,
          onChange: onChange,
          property: property,
          readOnly: true,
          readOnlySourceData: this.props.readOnlySourceData,
          ref: "input",
          resolver: resolver,
          value: value,
          className: className,
          subject: subject,
          getProperty: getProperty
        }));
      }

      var displayValue = "" + (0, _PropertyValueDisplay.getDisplayedValue)(property, value);
      var inputProps = (0, _extends2.default)({}, getTransferableProps(this.props), {
        readOnly: true,
        error: !(0, _PropertyValidations.isValidPropertyValue)(property, value),
        ref: 'input',
        value: displayValue
      });

      if (this.props.isExpandableTextInputEnabled && ((0, _PropertyIdentifier.isTextarea)(property) || (0, _PropertyIdentifier.isSingleLineText)(property))) {
        return _react.default.createElement(_UIExpandableText.default, {
          className: "p-top-2"
        }, _react.default.createElement(_UITextArea.default, inputProps, displayValue));
      }

      return _react.default.createElement(InputComponent, inputProps);
    }
  }]);
  return PropertyInputReadOnly;
}(_react.Component);

exports.default = PropertyInputReadOnly;
PropertyInputReadOnly.propTypes = propTypes;
module.exports = exports.default;